import { Component, OnInit } from '@angular/core';
import { DataService } from '../../../../../src/app/shared/services/data.service';
import { ResponseData, Result, Team } from 'src/app/shared/services/teacher.interface';

@Component({
  selector: 'app-result',
  templateUrl: './result.component.html',
  styleUrls: ['./result.component.scss']
})
export class ResultComponent implements OnInit {
  result : Team[] = [];

  constructor(private dataService:DataService) { }

  ngOnInit(): void {
    this.getResult()
  }
  getResult(){
    this.dataService.getGameResult().subscribe({
      next:(res:ResponseData<Result>) =>{
        this.result = res.data.teams
      },
      error:(err) =>{
        console.error(err)
      },
    })
  }

}
